import { useState } from "react";
import { useHistory } from "react-router-dom";
import { removeFilterSuffix } from "src/Components/DataTableControlled/utils";

export default function useQueryToState(tableId) {
  const history = useHistory();
  const [initialState] = useState(() => getInitialState(history, tableId));
  const changeQuery = (params) => {
    const readyParams = {};
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (typeof value === "object") {
        const { from, to } = value;
        if (from) {
          readyParams[`${key}[after]`] = from.toISOString();
        }
        if (to) {
          readyParams[`${key}[before]`] = to.toISOString();
        }
      } else {
        readyParams[key] = value;
      }
    });
    const searchParams = new URLSearchParams(readyParams);
    const queryString = `?${searchParams.toString()}`;
    history.push({
      hash: history.location.hash,
      search: queryString,
    });
  };

  return [initialState, changeQuery];
}

export function paramsToObject(entries) {
  const result = {};
  [...entries].forEach((entry) => {
    const [key, value] = entry;
    if (key.endsWith(["[after]"])) {
      const realKey = key.replace("[after]", "");
      if (!result[realKey]) {
        result[realKey] = {};
      }
      result[realKey].from = new Date(value);
    } else if (key.endsWith("[before]")) {
      const realKey = key.replace("[before]", "");
      if (!result[realKey]) {
        result[realKey] = {};
      }
      result[realKey].to = new Date(value);
    } else {
      result[key] = value;
    }
  });
  return result;
}

const getInitialState = (history, tableId) => {
  const urlParams = new URLSearchParams(history.location.search);
  const entries = urlParams.entries();
  const customParams = {};
  const restEntries = [];
  [...entries]?.forEach(([key, value]) => {
    if (
      tableId &&
      (key === `page_${tableId}` ||
        key === `pageSize_${tableId}` ||
        key === `orderKey_${tableId}` ||
        key === `orderDir_${tableId}`)
    ) {
      customParams[removeFilterSuffix(key, tableId)] = value;
    } else {
      restEntries.push([key, value]);
    }
  });
  return {
    ...customParams,
    ...paramsToObject(restEntries),
  };
};
